import React from "react";
import RequiresAuth from "./RequiresAuth";
import RequiresAdmin from "./RequiresAdmin";

const RequiresAuthAdmin = ({ children }) => {
  return (
    <RequiresAuth>
      <RequiresAdmin>
        {children}
      </RequiresAdmin>
    </RequiresAuth>
  );
};

export default RequiresAuthAdmin;